import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getPurchaseOrder = createAsyncThunk("client/get-purchase-order", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/purchaseOrder/api/v1/get-purchase-order`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("getPurchaseOrder API Response:", response.data);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
